import React from "react"
import { endOfMonth, endOfWeek, isSameDay, startOfMonth, startOfWeek, subMonths, subWeeks } from "date-fns"

export const useDateRangePresets = (firstDayOfWeek: DayOfWeek, labels?: DateRangePresetLabels): DateRangePreset[] => {
  return React.useMemo(() => {
    const today = new Date()
    const lastWeek = subWeeks(today, 1)
    const lastMonth = subMonths(today, 1)
    const weekOptions = { weekStartsOn: firstDayOfWeek }

    return [
      {
        label: labels?.thisWeek ?? "This week",
        fromDate: startOfWeek(today, weekOptions),
        toDate: clampFutureDate(endOfWeek(today, weekOptions), today),
      },
      {
        label: labels?.lastWeek ?? "Last week",
        fromDate: startOfWeek(lastWeek, weekOptions),
        toDate: endOfWeek(lastWeek, weekOptions),
      },
      {
        label: labels?.thisMonth ?? "This month",
        fromDate: startOfMonth(today),
        toDate: clampFutureDate(endOfMonth(today), today),
      },
      {
        label: labels?.lastMonth ?? "Last month",
        fromDate: startOfMonth(lastMonth),
        toDate: endOfMonth(lastMonth),
      },
    ]
  }, [firstDayOfWeek, labels])
}

export type DateRangePresetLabels = { thisWeek: string; lastWeek: string; thisMonth: string; lastMonth: string }

export const isSelectedDateRangePreset = (preset: DateRangePreset, currentDateRange: DateRange) => {
  return isSameDay(preset.fromDate, currentDateRange.fromDate) && isSameDay(preset.toDate, currentDateRange.toDate)
}

const clampFutureDate = (date: Date, today: Date) => {
  return date > today ? today : date
}

type DateRange = {
  fromDate: Date
  toDate: Date
}

export type DateRangePreset = DateRange & {
  label: string
}
